// src/routes/layoutRules.ts

const normalizePath = (path: string) => {
  if (!path) return "/";
  const clean = path.toLowerCase().split("?")[0].split("#")[0];

  if (clean.length > 1 && clean.endsWith("/")) {
    return clean.slice(0, -1);
  }

  return clean;
};

export const chooseActionRoutes = new Set([
  "/suprimentos",
  "/comercial",
  "/recursos-humanos",
  "/coordenacao",
  "/departamento-pessoal",
  "/departamento-tecnico",
  "/status-do-servico",
  "/governanca-qualidade-e-compliance",
  "/suprimentos/estoque-p-tecnicos-e-laboratorio",
  "/diretoria",
]);

export const isChooseActionRoute = (pathname: string) => {
  return chooseActionRoutes.has(normalizePath(pathname));
};

export const isNoPagePaddingRoute = (pathname: string) => {
  return isChooseActionRoute(pathname);
};
